import React, { useEffect, useRef, useId } from 'react';
import Swiper from 'swiper';
import { EffectFade, Pagination, Navigation, A11y } from 'swiper/modules';
import CountdownSwiperSlide from 'components/partials/parts/countdown-swiper-slide';
import { SwiperSlideProps } from 'types/swiper-slide-props';
import { ReactComponent as CaretLeftIcon } from "img/arrows/caret-left.svg";
import { ReactComponent as CaretRightIcon } from "img/arrows/caret-right.svg";

type CountdownSliderProps = {
    banner_color_class: string;
    section_title: string;
    slides: SwiperSlideProps[];
};

const CountdownSlider: React.FC<CountdownSliderProps> = ({ banner_color_class = 'bg-brand-orange', section_title, slides }) => {
    const swiperRef = useRef(null);

    // ensures unique id for each countdown swiper
    const id = useId().replaceAll(':', '');

    useEffect(() => {
        if (swiperRef.current !== null) {
            const swiperInstance = new Swiper(swiperRef.current, {
                modules: [EffectFade, Pagination, Navigation, A11y],
                loop: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: `.js-countdown-slideshow-${id} .swiper-nav .swiper-nav-next`,
                    prevEl: `.js-countdown-slideshow-${id} .swiper-nav .swiper-nav-prev`,
                },
                pagination: {
                    el: `.js-countdown-slideshow-${id} .swiper-nav .swiper-pagination`,
                    type: 'bullets',
                    hideOnClick: false,
                    clickable: true,
                },
            });

            if (process.env.GATSBY_SERVER_ENV === 'dev') {
                // Attach the swiper instance to the window object
                // for debugging purposes.increment swiperCount to get unique name
                // console commands:
                // window.swiperCountdownSliderXXX.slideNext();
                // window.swiperCountdownSliderXXX.slidePrev();
                (window as any)[`swiperCountdownSlider${id}`] = swiperInstance;
            }

        }
    }, []);

    return (
        <div className={`pattern pattern--countdown-slider`}>
            <div className="container">
                <div className={`countdown-slider pattern--has-bgcolor ${banner_color_class}`}>
                    <h2 className="section-title">{section_title}</h2>
                    <div className={`swiper js-countdown-slideshow js-countdown-slideshow-${id}`} ref={swiperRef}>
                        <div className="swiper-wrapper">
                            {slides.map((slide, index) => (
                                <CountdownSwiperSlide
                                    key={index}
                                    logo={slide.logo}
                                    tagline={slide.tagline}
                                    eventStartDate={slide.eventStartDate}
                                    eventEndDate={slide.eventEndDate}
                                />
                            ))}
                        </div>
                        <div className="swiper-nav">
                            <div className="swiper-nav-prev btn-circle-arrow"><CaretLeftIcon /></div>
                            <div className="swiper-pagination"></div>
                            <div className="swiper-nav-next btn-circle-arrow"><CaretRightIcon /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountdownSlider;